<template>
  <div id="app">
    <myHeader />
    <router-view />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
export default {
  components: {
    myHeader: Header
  }
};
</script>

<style lang="scss">
body,
head {
  margin: 0;
  padding: 0;
  color: #2c3e50;
  background-color: #f7f7f7;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}
#app {
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  background-color: #f7f7f7;
}
</style>
